import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './BindModal.module.css';
import BulkBindInstruction from '../../BulkBindInstruction/BulkBindInstruction';
import BulkBindTemplates from '../../BulkBindTemplates/BulkBindTemplates';
import BulkBindRosters from '../../BulkBindRosters/BulkBindRosters';
import { SurfaceBar } from '../../SurfaceBar/SurfaceBar';


const TABS = [
	{ id: 'instructions', label: 'Инструкции' },
	{ id: 'templates', label: 'Документы' },
	{ id: 'rosters', label: 'Перечни' }
];

const HELPER_TEXT = {
	instructions: (
		<p className={styles.helperText}>
			Отметьте необходимые инструкции — они автоматически отобразятся во всех связанных документах и в личном кабинете сотрудника.
		</p>
	),
	templates: (
		<p className={styles.helperText}>
			Отметьте необходимые для вашей профессии документы - они автоматически добавятся в контрольную{' '}
			<Link className={styles.helperLink} to="/admin/deadlines">
				таблицу и график
			</Link>
			. В них вы сможете отслеживать статус оформления и контролировать сроки выполнения.
		</p>
	),
	rosters: (
		<p className={styles.helperText}>
			Отметьте, в какие перечни входит каждая профессия: освобождение от первичного инструктажа, стажировка и программы обучения.
		</p>
	)
};

export function BindModal({ professions, instructions }) {
	const [activeTab, setActiveTab] = useState('instructions');
	const instructionText = HELPER_TEXT[activeTab];

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>Привязки</h1>
			<SurfaceBar
				className={styles.surfaceBar}
				actions={instructionText}
				tabs={TABS}
				activeTab={activeTab}
				onTabChange={setActiveTab}
			/>
			<div className={styles.content}>
				{activeTab === 'instructions' && (
					<BulkBindInstruction
						professions={professions}
						instructions={instructions}
					/>
				)}
				{activeTab === 'templates' && (
					<BulkBindTemplates professions={professions} />
				)}
				{activeTab === 'rosters' && (
					<BulkBindRosters professions={professions} />
				)}
			</div>
		</div>
	);
}
